import i18n from './index';

// Bundled language pack for short terms that come from data rather than from
// source code (service names, plan types, statuses…). Matching ignores case,
// hyphens and extra spaces. Anything not in the pack renders unchanged and is
// logged once in dev so it can be added to src/i18n/locales/*/dynamic.json.
// Do NOT use for people's names, addresses, or chat/SMS/email bodies.
const normalize = (s: string) => s.toLowerCase().replace(/[-_]+/g, ' ').replace(/\s+/g, ' ').trim();

const indexCache = new Map<string, Map<string, string>>();
function getIndex(lng: string): Map<string, string> {
  let idx = indexCache.get(lng);
  if (!idx) {
    idx = new Map();
    const bundle = (i18n.getResourceBundle(lng, 'dynamic') ?? {}) as Record<string, string>;
    for (const [en, translated] of Object.entries(bundle)) idx.set(normalize(en), translated);
    indexCache.set(lng, idx);
  }
  return idx;
}

const reported = new Set<string>();

export function translateDynamic(text: string | undefined | null): string {
  if (!text) return text ?? '';
  const lng = (i18n.language || 'en').slice(0, 2);
  if (lng === 'en') return text;
  const hit = getIndex(lng).get(normalize(text));
  if (hit) {
    const lowerInput = text[0] === text[0].toLowerCase() && text[0] !== text[0].toUpperCase();
    const acronym = /^[A-Z]{2,}/.test(hit);
    return lowerInput && !acronym ? hit[0].toLowerCase() + hit.slice(1) : hit;
  }
  if (import.meta.env.DEV && !reported.has(text)) {
    reported.add(text);
    console.warn(`[i18n] Not in language pack: "${text}" — add to locales/*/dynamic.json`);
  }
  return text;
}
